import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";

import { PROJECT_USER_GET_ALL_WITH_ACCESS_TO_PROJECT } from "./useProjectUserGetAllWithAccessToProject";

const PROJECT_USER_ASSIGN_ROLE = gql(`
    mutation ProjectUserAssignRole($input: GqlProjectUserAssignRoleInput!) {
        projectUserAssignRole(input: $input) {
            id
        }
    }
`);

export default function useProjectUserAssignRole() {
    const [mutate, { loading, error, data }] = useMutation(PROJECT_USER_ASSIGN_ROLE, {
        refetchQueries: [PROJECT_USER_GET_ALL_WITH_ACCESS_TO_PROJECT],
    });

    const assignRole = (projectId: string, userId: string, roleId: string) =>
        mutate({ variables: { input: { projectId, userId, roleId } } });

    return {
        assignRole,
        loading,
        error,
        updatedUser: data?.projectUserAssignRole,
    };
}
